var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-5" }, [
    _c(
      "div",
      { staticClass: "p-20 bg-white" },
      [
        _c(
          "el-form",
          { ref: "form", attrs: { "label-width": "auto" } },
          [
            _vm.form.params.length < 5
              ? _c(
                  "div",
                  { staticClass: "mb-10" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.form.params.push({
                              type: "text",
                              content: "",
                            })
                          },
                        },
                      },
                      [_vm._v("添加文本")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "ml-30",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.form.params.push({
                              type: "image",
                              content: [],
                            })
                          },
                        },
                      },
                      [_vm._v("添加图片")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("el-form-item", { attrs: { label: "跳转小程序链接：" } }, [
              _c("div", { staticClass: "flex align-start" }, [
                _vm._v("\n          " + _vm._s(_vm.atStr) + "\n          "),
                _c(
                  "a",
                  {
                    staticClass: "ml-10 cursor text-blue",
                    on: {
                      click: function ($event) {
                        _vm.copyText(_vm.atStr)
                        _vm.$message({ message: "复制成功", type: "success" })
                      },
                    },
                  },
                  [_vm._v("复制链接")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "fs-s2 text-gray" }, [
                _vm._v(
                  "注：点击复制链接，将复制的内容放入关注回复的文本消息中，用户即可点击跳转到小程序中。"
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.form.params, function (item, index) {
              return [
                item.type == "text"
                  ? _c("el-form-item", { attrs: { label: "文本回复：" } }, [
                      _c(
                        "div",
                        { staticClass: "flex align-start" },
                        [
                          _c("el-input", {
                            attrs: { rows: "4", type: "textarea" },
                            model: {
                              value: item.content,
                              callback: function ($$v) {
                                _vm.$set(item, "content", $$v)
                              },
                              expression: "item.content",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "ml-30",
                            attrs: { type: "danger", icon: "el-icon-minus" },
                            on: {
                              click: function ($event) {
                                return _vm.form.params.splice(index, 1)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.type == "image"
                  ? _c("el-form-item", { attrs: { label: "图片回复：" } }, [
                      _c(
                        "div",
                        { staticClass: "flex align-start" },
                        [
                          _c("upload", {
                            attrs: {
                              upObj: _vm.upObj,
                              emitUrl: false,
                              action: "agentapi/action/wx_material_updimg",
                            },
                            model: {
                              value: item.content,
                              callback: function ($$v) {
                                _vm.$set(item, "content", $$v)
                              },
                              expression: "item.content",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "ml-30",
                            attrs: { type: "danger", icon: "el-icon-minus" },
                            on: {
                              click: function ($event) {
                                return _vm.form.params.splice(index, 1)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            }),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.postCard()
                      },
                    },
                  },
                  [_vm._v("立即提交")]
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }